import Typography from '@elementor/ui/Typography';
import PropTypes from 'prop-types';
import { StyledMainLayoutContent } from '@styles/app.styles';
import { __ } from '@utils/i18n';

const MainLayoutContainer = ({ children }) => {
	return (
		<StyledMainLayoutContent>
			<Typography variant="body1" as="h3" sx={{ color: 'text.secondary' }}>
				{__('All issues')}
			</Typography>

			{children}
		</StyledMainLayoutContent>
	);
};

MainLayoutContainer.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MainLayoutContainer;
